let diffInitialized = false;

const getComparableCellValue = (cell) => {
  const certificateImages = cell.querySelectorAll(".table__certificate-image");

  if (certificateImages.length) {
    return [...certificateImages]
      .map((img) => img.getAttribute("src") || "")
      .join("|")
      .trim();
  }

  return cell.textContent.replace(/\s+/g, " ").trim();
};

const clearDifferences = () => {
  document.querySelectorAll(".table__row.has-differences").forEach((row) => {
    row.classList.remove("has-differences");
  });

  document.querySelectorAll(".table__cell.is-different").forEach((cell) => {
    cell.classList.remove("is-different");
  });
};

const highlightDifferences = () => {
  const rows = document.querySelectorAll(".table__row[data-row-key]");

  rows.forEach((row) => {
    const cells = [...row.querySelectorAll(".table__row-data .table__cell")];

    row.classList.remove("has-differences");
    cells.forEach((cell) => cell.classList.remove("is-different"));

    if (cells.length < 2) {
      return;
    }

    const baseValue = getComparableCellValue(cells[0]);
    let hasDifferences = false;

    cells.slice(1).forEach((cell) => {
      const currentValue = getComparableCellValue(cell);

      if (currentValue !== baseValue) {
        cell.classList.add("is-different");
        hasDifferences = true;
      }
    });

    if (hasDifferences) {
      row.classList.add("has-differences");
    }
  });
};

export const refreshDifferencesState = () => {
  const button = document.querySelector("[data-show-diff]");

  if (button?.classList.contains("is-active")) {
    highlightDifferences();
  }
};

export const initShowDifferences = () => {
  if (diffInitialized) return;
  diffInitialized = true;

  document.addEventListener("click", (event) => {
    const button = event.target.closest("[data-show-diff]");
    if (!button) return;

    const isActive = button.classList.toggle("is-active");

    if (isActive) {
      highlightDifferences();
      return;
    }

    clearDifferences();
  });
};